<template>
    <div>
        <div>
            <v-row>
                <v-col>
                    <h2>Review Booking</h2>

                    <v-row>
                        <v-col cols="6">
                            <h3>Booker</h3>
                            <span v-if="booking.contactName">{{booking.contactName}}</span>
                            <address class="vcard ">
                      <span class="adr d-flex flex-column">
                        <span class="street-address" v-if="booking.contactAddress1">{{booking.contactAddress1}}</span>
                        <span class="street-address" v-if="booking.contactAddress2">{{booking.contactAddress2}}</span>
                        <span class="street-address" v-if="booking.contactAddress3">{{booking.contactAddress3}}</span>
                        <span class="locality" v-if="booking.contactTown">{{booking.contactTown}}</span>
                        <span class="region" v-if="booking.contactCounty">{{booking.contactCounty}}</span>
                        <span class="postal-code" v-if="booking.contactPostcode">{{booking.contactPostcode}}</span>
                      </span>
                            </address>
                            <div class="d-flex flex-column">
                                <span v-if="booking.contactPhone">{{booking.contactPhone}}</span>
                                <span v-if="booking.contactEmail">{{booking.contactEmail}}</span>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <h3>Invoice Contact</h3>
                            <span class="street-address" v-if="booking.invoiceName">{{booking.invoiceName}}</span>
                            <address class="vcard ">
                              <span class="adr d-flex flex-column">
                                <span class="street-address" v-if="booking.invoiceAddress1">{{booking.invoiceAddress1}}</span>
                                <span class="street-address" v-if="booking.invoiceAddress2">{{booking.invoiceAddress2}}</span>
                                <span class="street-address" v-if="booking.invoiceAddress3">{{booking.invoiceAddress3}}</span>
                                <span class="locality" v-if="booking.invoiceTown">{{booking.invoiceTown}}</span>
                                <span class="region" v-if="booking.invoiceCounty">{{booking.invoiceCounty}}</span>
                                <span class="postal-code" v-if="booking.invoicePostcode">{{booking.invoicePostcode}}</span>
                              </span>
                            </address>
                            <div class="d-flex flex-column">
                                <span v-if="booking.invoicePhone">{{booking.invoicePhone}}</span>
                                <span v-if="booking.invoiceEmail">{{booking.invoiceEmail}}</span>
                            </div>

                        </v-col>
                    </v-row>

                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <th>Title</th>
                                    <td>{{booking.courseTitle}}</td>
                                </tr>
                                <tr>
                                    <th>Date</th>
                                    <td>{{booking.bookingDate|formatDate}}</td>
                                </tr>
                                <tr>
                                    <th>Account Manager</th>
                                    <td><AccountManager v-model="booking.accountManager" text /></td>
                                </tr>
                                <tr>
                                    <th>Delegates</th>
                                    <td>
                                        {{booking.delegates}}
                                        <span v-if="booking.courseRate > 0">@ {{booking.courseRate | toCurrency}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>PO Reference</th>
                                    <td>
                                        {{booking.customerPoRef}}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Days</th>
                                    <td>
                                        {{booking.days}}
                                        <span v-if="booking.dayRate > 0">@ {{booking.dayRate | toCurrency}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total Price</th>
                                    <td>{{booking.totalPrice | toCurrency}}</td>
                                </tr>
                                <tr>
                                    <th>VAT</th>
                                    <td>{{booking.vatAmount | toCurrency}}</td>
                                </tr>
                                <tr>
                                    <th>Gross Total Price</th>
                                    <td>{{booking.grossPrice | toCurrency}}</td>
                                </tr>
                                <tr>
                                    <th>Printed Notes</th>
                                    <td>{{booking.printedNotes}}</td>
                                </tr>
                                <tr>
                                    <th>Non Printed Notes</th>
                                    <td>{{booking.nonPrintedNotes}}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                </v-col>
            </v-row>


            <span>{{contactName}}</span>

        </div>
    </div>
</template>

<script>
    import AccountManager from "../../AutoCompletes/AccountManager";

    export default {
        components: {AccountManager},
        props: {
            booking: {
                type: Object
            }
        },
    }
</script>
